import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../backend/firebaseConfig"; // ensure storage is exported

const GUIDE_FOLDER = "check2/Guide7";

// keeps filename safe for Storage paths
const safeName = (name = "Check Guide.pdf") =>
  name
    .replace(/[^\w.\- ()]/g, "_")
    .replace(/\s+/g, " ")
    .trim();

export function uploadCheck2Guide({
  file,
  updatedByEmail = "",
  onProgress, // (pct)=>void
  overwriteLatest = true, // if true, always upload as "Check Guide.pdf"
} = {}) {
  if (!file) throw new Error("No file selected");

  const isPdf =
    file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
  if (!isPdf) throw new Error("Please upload a PDF file.");

  const fileName = overwriteLatest ? "Check Guide.pdf" : safeName(file.name);
  const storagePath = `${GUIDE_FOLDER}/${fileName}`;

  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, storagePath);

    const task = uploadBytesResumable(storageRef, file, {
      contentType: "application/pdf",
      cacheControl: "public,max-age=3600",
    });

    task.on(
      "state_changed",
      (snap) => {
        const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
        onProgress?.(pct);
      },
      reject,
      async () => {
        try {
          const url = await getDownloadURL(task.snapshot.ref);

          // Save the *working* download URL (includes token)
          await setDoc(
            doc(db, "Compliance", "Check²"),
            {
              guide: url,
              guidePath: storagePath,
              guideUpdatedBy: updatedByEmail || "",
              guideUpdatedAt: serverTimestamp(),
            },
            { merge: true },
          );

          resolve(url);
        } catch (e) {
          reject(e);
        }
      },
    );
  });
}
